(function () {
    'use strict';

    angular
        .module('app.advertiserAddInfluencerToCampaigns', [])
        .controller('advertiserAddInfluencerToCampaignsCtrl', ['$scope', '$modal', '$http', '$rootScope', '$modalInstance',
            'advertiserAddInfluencerToCampaignsService',
            function ($scope, $modal, $http, $rootScope, $modalInstance, advertiserAddInfluencerToCampaignsService) {
                $scope.campaignList = [];

                $scope.selectedAdvertiser = $rootScope.currentUser.company.id;
                if ($rootScope.sideMenuSelections.advertiserId != null || $rootScope.sideMenuSelections.advertiserId !== undefined) {
                    $scope.selectedAdvertiser = $rootScope.sideMenuSelections.advertiserId;
                }

                $scope.getAvailableCampaigns = function () {
                    var campaign_id = $rootScope.se
                    advertiserAddInfluencerToCampaignsService.getAvailableCampaignsToAddInfluencer($scope.selectedAdvertiser, $scope.influencer_id)
                        .then(function (response) {
                            $scope.campaignList = response.data;
                        }, function (errorResponse) {
                            $rootScope.handleRequestError(errorResponse, $scope);
                        });
                }

                $scope.selectCampaign = function (campaign) {
                    campaign.ticked = !campaign.ticked;
                }

                $scope.sendInvite = function () {
                    var requestData = _.filter($scope.campaignList, function (item) {
                        return item.ticked === true;
                    }).map(function (item) {
                        return {
                            campaign_id: item.id,
                            influencer_id: $scope.influencer_id,
                            status: item.accepted ? 'accepted' : null
                        };
                    })

                    var params = {
                        campaigns: requestData
                    }

                    advertiserAddInfluencerToCampaignsService.addInfluencerToCampaigns(params)
                        .then(function (response) {
                            $scope.closeModal();
                        }, function (errorResponse) {
                            $rootScope.handleRequestError(errorResponse, $scope);
                        });
                }

                $scope.closeModal = function () {
                    $modalInstance.close();
                }

                $scope.getAvailableCampaigns();
            }
        ]);
})();
